// @ts-strict-ignore
import Idle from './Idle'
import Loading from './Loading'
import { Box } from '@components/gassan-ui'
import { Item } from '@lib/kontent'
import { NewsItem as NewsItemModel } from '@lib/kontent/models/NewsItem'
import { FC } from 'react'

type Variant = {
  variant: 'regular' | 'wide'
}

type LoadingType = {
  status?: 'loading'
}

type IdleType = Item<NewsItemModel> & {
  status?: 'idle'
}

type StatusProps = IdleType | LoadingType

type Props = Variant & StatusProps

const NewsItem: FC<Props> = (props) => {
  const isRegular = props.variant === 'regular'
  return (
    <Box gridColumn={{ _: 'auto', medium: isRegular ? 'auto / span 2' : 'auto / span 3' }}>
      {props.status === 'loading' ? (
        <Loading isRegular={isRegular} />
      ) : (
        <Idle isRegular={isRegular} {...props} />
      )}
    </Box>
  )
}

export default NewsItem
